import {AstView, EnrichedAstNode} from '../types';
import {visitor} from '../helpers';

export const removeSmallPaddingMargin = (tree: EnrichedAstNode, view: AstView) => {
    visitor(tree, view.meta, (currentNode) => {
        removeSmallPaddingMarginNode(currentNode);
    });
};

const MarginThreshold = 3;
const PaddingThreshold = 3;

export const removeSmallPaddingMarginNode = (currentNode: EnrichedAstNode) => {
    ['Top', 'Bottom', 'Right', 'Left'].forEach((value) => {
        if (currentNode.position['margin' + value] < MarginThreshold) {
            currentNode.position['margin' + value] = 0;
        }
        if (currentNode.innerPosition['padding' + value] < PaddingThreshold) {
            currentNode.innerPosition['padding' + value] = 0;
        }
    });
};

export const hasSmallPaddingMargin = (tree: EnrichedAstNode, view: AstView) => {
    let hasSmallPaddingMargin = false;

    visitor(tree, view.meta, (currentNode) => {
        const result = checkNodeForSmallMarginPadding(currentNode);
        if (result) {
            hasSmallPaddingMargin = true;
        }
    });
    return hasSmallPaddingMargin;
};
export const checkNodeForSmallMarginPadding = (currentNode: EnrichedAstNode) => {
    return ['Top', 'Bottom', 'Right', 'Left'].some((value) => {
        const marginValue = currentNode.position['margin' + value];
        const paddingValue = currentNode.innerPosition['padding' + value];
        const userSetMargin =
            currentNode.inputLayoutAbstraction.userMarginSet &&
            currentNode.inputLayoutAbstraction.userMarginSet['margin' + value];
        const userSetPadding =
            currentNode.inputLayoutAbstraction.userPaddingSet &&
            currentNode.inputLayoutAbstraction.userPaddingSet['padding' + value];

        if (marginValue < MarginThreshold && marginValue > 0 && !userSetMargin) {
            return true;
        }
        if (paddingValue < PaddingThreshold && paddingValue > 0 && !userSetPadding) {
            return true;
        }
        return false;
    });
};
